// Component inspired by this tutorial - https://medium.com/@ItsMeDannyZ/how-to-build-a-progress-bar-with-react-8c5e79731d1f

import React from 'react';
import './ProgressBar.scss';

export default function ProgressBar(props) {
  let graphColor = props.percentage == 100 ? '#5DB348' : props.percentage > 0 ? '#f5a623' : '#9b9b9b';
  return (
      <div className={'progress-bar' + (props.thin ? ' thin' : '')}>
        <div className="filler" style={{ width: `${props.percentage}%`, backgroundColor: graphColor }} />
      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.js